import React from 'react';
import classNames from 'classnames/bind';

import { ProductPodPlaceholder } from '@thd-olt-component-react/product-pod';

import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { CategoryProducts } from '../CategoryProducts/CategoryProducts';
import styles from './special-buy-carousel.module.scss';

const cNames = classNames.bind(styles);

const SpecialBuyCarousel = () => {
  const { categories, isSpecialBuyDataLoading } = useSpecialBuy();

  const carouselClassNames = cNames('special-buy-carousel', {
    'special-buy-carousel--hidden': !categories.length && !isSpecialBuyDataLoading,
  });

  return (
    <section className={carouselClassNames}>
      {isSpecialBuyDataLoading ? (
        <ProductPodPlaceholder podsCount={5} />
      ) : (
        <>
          {categories.map((category) => (
            <CategoryProducts
              key={category.categoryId}
              category={category}
            />
          ))}
        </>
      )}
    </section>
  );
};

SpecialBuyCarousel.displayName = 'SpecialBuyCarousel';

export { SpecialBuyCarousel };
